import React from 'react';
import { AiFillEyeInvisible, AiFillEye } from 'react-icons/ai';
import { Field, ErrorMessage } from 'formik';

const iconStyle = "w-6 h-6 absolute right-0 m-3 text-gray-400 cursor-pointer";

const Input = ({ label, type, name, placeholder, handleShowPassword }) => {
  
  return (
    <div>
        <label className="block text-sm font-medium leading-6 text-gray-900">{label}</label>
        <div className="relative mt-2">
        {name === 'password' 
      ? (
        <span onClick={handleShowPassword}> 
            {type === 'password' 
              ? <AiFillEye className={iconStyle} /> 
              : <AiFillEyeInvisible className={iconStyle} /> 
            }
        </span>
        ) : null
      }
          <Field name={name} type={type} placeholder={placeholder} className="outline-none block w-full rounded-md border-0 py-3 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 text-lg sm:leading-6" />
          <ErrorMessage name={name} component="div" className="text-red-600" />
        </div>
      </div>
  )
}

export default Input;